export default ({
  name,
  callback
}) => {
  if (!window.ReactNativeWebView) { return }
  window.ReactNativeResponses[name] = callback
  window.ReactNativeResponsesQueue?.forEach(({
    method,
    params
  }) => {
    if (name === method) {
      callback(params)
    }
  })
}
